import React, { useEffect, useMemo, useState } from 'react'
import { Input, Tooltip } from 'antd';
import { CloseCircleTwoTone } from '@ant-design/icons';

import './ShortAnswer.css';
import MobileVirtualKeyboard from './MobileVirtualKeyboard';

export default function ShortAnswerItem(props) {

   // Normalize incoming value. In edit mode this is usually a string.
   // In some view/answer modes it can be an array.
   const initialValue = useMemo(() => {
      if (Array.isArray(props.correct)) return props.correct?.[0] ?? '';
      return props.correct ?? '';
   }, [props.correct]);

   const [value, setValue] = useState(initialValue);

   useEffect(() => {
      setValue(initialValue);
   }, [initialValue]);

   const handleChangeValue = (next) => setValue(next);

   const handleMobileChangeValue = (next) => {
      setValue(next);
      props.parentCallback("update-input", next, props.id);
   };

   const handleRemoveOption = (idx) => {
      props.parentCallback("remove", "", idx);
   }

   const handleUpdateInput = () => {
      // Avoid marking parent dirty when the user only focuses/blurs without
      // actually changing the value.
      if (value === initialValue) return;
      props.parentCallback("update-input", value, props.id);
   };

   return (
      <div onBlur={handleUpdateInput} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '7px' }}>
         {props.mobileVirtualKeyboard && props.mode === "answer"
            ? (
               <MobileVirtualKeyboard
                  value={value}
                  onChange={handleMobileChangeValue}
                  placeholder="Tap to type your answer"
               />
            )
            : (
               <Input
                  autoComplete='off'
                  allowClear
                  id={props.id}
                  name={props.id}
                  rows={1}
                  value={value}
                  onChange={(event) => handleChangeValue(event.target.value)}
                  disabled={props.mode.includes("assign") || props.mode.includes("view") ? true : false}
                  style={{ borderRadius: 7, width: "100%", marginRight: '7px', fontSize: '14px' }}
               />
            )}
         {
            props.mode === "answer" || props.mode.includes("assign") || props.mode.includes("view")
               ?
               <></>
               :
               <Tooltip placement="right" title='Remove answer key'>
                  <CloseCircleTwoTone twoToneColor="red" style={{ cursor: "pointer", fontSize: "16px" }} onClick={() => handleRemoveOption(props.id)} />
               </Tooltip>
         }
      </div>
   )
}
